module KendoWidgets
{
	export class DropDownTreeOptions implements kendo.ui.DropDownTreeOptions
	{
		dataTextField?: string;
		dataValueField?: string;
		filter?: string;
		showFilter?: boolean;
		autoWidth?: boolean;
		tagMode?: string;
		checkAllTemplate?: string;
		noDataTemplate?: string;
		dataSource?: any;
		checkAll?: boolean;
		parentCheckbox?: boolean;
		autoClose?: boolean;
		messages?: kendo.ui.DropDownTreeMessages;
		checkboxes?: boolean | any;
		clearButton?: boolean;
		placeholder?: string;
		template?: string | Function;
		text?: string;
		value?: string | any;
		height?: string | number;
		enable?: boolean;
		width?: string | number;
		allSelectedMessage?: string;
		closeOnClick?: boolean;
		expand?: TreeExpandEnum;
		wrapper?: string | JQuery | Element;
		css?: string;
		imageUrl?: IconClass | string;

		label?: string;
		labelColor?: string;
		labelPosition?: LabelPositionEnum;
		labelClass?: string;
		labelWidth?: number;

		change?(e: kendo.ui.DropDownTreeChangeEvent): void;
		close?(e: kendo.ui.DropDownTreeCloseEvent): void;
		dataBound?(e: kendo.ui.DropDownTreeDataBoundEvent): void;
		filtering?(e: kendo.ui.DropDownTreeFilteringEvent): void;
		open?(e: kendo.ui.DropDownTreeOpenEvent): void;
		select?(e: kendo.ui.DropDownTreeSelectEvent): void;
	}

	export class DropDownTree extends kendo.ui.DropDownTree implements KendoWidget, IControlWithDatasource
	{
		public controlType(): ControlTypeEnum { return ControlTypeEnum.DropDownTree; }
		private _firstLoad: boolean;
		private _selectedItem: any;
		private _isClearing: boolean;

		constructor(element: Element, options?: KendoWidgets.DropDownTreeOptions)
		{
			if (options == null)
				options = new KendoWidgets.DropDownTreeOptions();

			//#region Default options
			if (options.checkboxes == null) options.checkboxes = false;
			if (options.dataTextField == null) options.dataTextField = "text";
			if (options.dataValueField == null) options.dataValueField = "value";
			if (options.autoWidth == null) options.autoWidth = true;
			if (options.tagMode == null) options.tagMode = "single";
			if (options.checkAllTemplate == null) options.checkAllTemplate = "Seleziona tutti";
			if (options.noDataTemplate == null) options.noDataTemplate = "Nessun risultato";
			if (options.checkAll == null) options.checkAll = true;
			if (options.autoClose == null) options.autoClose = !options.checkboxes;
			if (options.messages == null) options.messages = { singleTag: "elementi" };
			if (options.clearButton == null) options.clearButton = !options.checkboxes;
			if (options.placeholder == null) options.placeholder = "Seleziona...";
			if (options.checkboxes == true) options.checkboxes = { checkChildren: true };
			if (options.filter == null) options.filter = "contains";
			if (options.showFilter == null) options.showFilter = true;
			if (options.allSelectedMessage == null) options.allSelectedMessage = "Tutti selezionati";
			if (options.width == null) options.width = 190;
			if (options.closeOnClick == null) options.closeOnClick = false;
			if (options.expand == null) options.expand = TreeExpandEnum.None;
			if (options.parentCheckbox == null) options.parentCheckbox = true;

			if (!options.showFilter)
				options.filter = "none";
			//#endregion

			//#region Change
			let changeUserOverride = options.change;
			options.change = function (e: kendo.ui.DropDownTreeChangeEvent)
			{
				let allItems = (e.sender as KendoWidgets.DropDownTree).getAllItems();
				let selectedItems = allItems.filter(k => k.checked);

				that.writeTextByValues();

				if (changeUserOverride != null && (e as any).callBack != false)
				{
					window.setTimeout(() =>
					{
						(e.sender as any).selectedItem = (e.sender as KendoWidgets.DropDownTree)._selectedItem;
						if ((e.sender as any)._isClearing !== true)
							changeUserOverride!(e);
					});
				}

				//#region Close on click
				if (options!.closeOnClick && (e as any).callBack == null)
					e.sender.close();
				//#endregion

				if (selectedItems.length > 0)
					e.sender.element.parent().find(".k-multiselect-wrap span.k-input.k-readonly").hide();
			}
			//#endregion

			//#region Width
			if (typeof (options.width) == "number")
				options.width = options.width + "px";

			(element as HTMLElement).style.cssText += "width: " + options.width;
			//#endregion

			super(element, options);
			let that = this;
			element.parentElement!.id = element.id + "Parent";
			$(element).parent().addClass("controlParent");

			if (options.checkboxes === false || options.checkboxes == null)
				$(element).parent().addClass("dropdowntree_noCheckboxes");
			else
				$(element).parent().addClass("dropdowntree_checkboxes");

			if (options.value != null)
				this.trigger("change");

			//#region Single item
			if (options.dataSource != null && options.dataSource.length <= 10)
			{
				this.popup.element.find(".k-list-filter").hide();

				if (options.dataSource.length < 5)
					this.popup.element.find(".k-check-all").hide();
			}
			//#endregion

			//#region Label
			if (options.label != null && !this._firstLoad)
			{
				this._firstLoad = true;

				$("#" + element.id + "Label").remove();
				let label = document.createElement("label");
				label.id = element.id + "Label";
				$(label).kendoLabel(
					{
						text: options.label,
						color: (options.labelColor != null) ? options.labelColor : KendoWidgets.ColorEnum.BlueVettore,
						class: options.labelClass,
						height: 21,
						fontSize: 14,
						width: (options.labelWidth != null) ? options.labelWidth : "auto"
					});

				//#region Label position
				if (options.labelPosition == null) options.labelPosition = LabelPositionEnum.Top;
				switch (options.labelPosition)
				{
					case LabelPositionEnum.Top:
						{
							$(label).addClass("k-label-top");
							element.parentElement!.style.cssText += "display: inline-flex; flex-direction: column;";
							element.parentElement!.insertBefore(label, element.parentElement!.firstChild);
						}
						break;
					case LabelPositionEnum.Left:
						{
							$(label).addClass("k-label-left");
							element.parentElement!.insertBefore(label, element.parentElement!.firstChild);
							label.style.cssText += "margin-right: 5px";

							//if (options.width == "100%")
							//	element.parentElement!.style.cssText += "width: Calc(100% - " + (label.clientWidth + 5) + "px)";
							//else
							//	element.parentElement!.style.cssText += "width: " + (options.width.getNumericPart() + label.clientWidth + 5) + "px !important;";
						}
						break;
					case LabelPositionEnum.Right:
						{
							$(label).addClass("k-label-right");
							element.parentElement!.append(label);
							label.style.cssText += "margin-left: 5px";

							//if (options.width == "100%")
							//	element.parentElement!.style.cssText += "width: Calc(100% - " + (label.clientWidth + 5) + "px)";
							//else
							//	element.parentElement!.style.cssText += "width: " + (options.width.getNumericPart() + label.clientWidth + 5) + "px !important;";
						}
						break;
					case LabelPositionEnum.Bottom:
						{
							$(label).addClass("k-label-bottom");
							element.parentElement!.style.cssText += "display: inline-flex; flex-direction: column;";
							element.parentElement!.append(label);
						}
						break;
				}
				//#endregion
			}
			//#endregion

			//#region Icon arrow
			let iconArrow = document.createElement("span");
			iconArrow.classList.add("k-icon", "k-i-arrow-60-down");
			iconArrow.style.cssText += "position: absolute; right: 3px; top: 6px;";

			if (element != null && element.parentElement != null && element.parentElement.firstElementChild != null)
				element.parentElement.firstElementChild.after(iconArrow);
			//#endregion

			//#region Image url
			if (options.imageUrl != null)
			{
				window.setTimeout(() =>
				{
					let div = $(element).parent().find(".k-multiselect-wrap")[0];
					if (div != null)
					{
						$(element).parent().find(".k-multiselect-wrap")[0].style.cssText += `
							background-image: url("` + options!.imageUrl + `");
							background-position: 4px 5px;
							background-repeat: no-repeat;
							padding-left: 18px !important;
					`;
					}
				});
			}
			//#endregion

			//#region Checkbox click
			if (options.checkboxes)
			{
				window.setTimeout(() =>
				{
					let treeView = this.treeview;
					let allLiItems = this.getAllLiItems();
					for (let liItem of allLiItems)
					{
						$(liItem).click((e) =>
						{
							let dataItem = treeView.dataItem(liItem);
							that._selectedItem = dataItem;
						});
					}
				}, 500);
			}

			// To check all children of parent group
			this.treeview.setOptions(
				{
					check: (e: any) =>
					{
						let checkBox = $(e.node).find('.k-checkbox').first();
						let state = checkBox.is(':checked');
						$(e.node).find(".k-group input").prop('checked', state);

						// DataSource
						$(e.node).find(".k-group li.k-item").each(function (index, element)
						{
							e.sender.dataSource.getByUid($(element).attr('data-uid')).checked = state;
						});

						this.writeTextByValues();
					}
				});
			//#endregion

			//#region CSS
			if (options.css != null)
				this.element.parent()[0].style.cssText += options.css;
			//#endregion

			//#region Wrapper
			if (options.wrapper != null)
				window.setTimeout(() => this.element.parent().wrap(options!.wrapper!));
			//#endregion
		}

		private getOptions()
		{
			return (this.options as KendoWidgets.DropDownTreeOptions);
		}

		setValues(values?: any | string, triggerChange: boolean = true)
		{
			if (typeof (values) == "string")
				values = [values];

			this.value(values);
			if (values != null)
			{
				if (triggerChange)
					this.trigger("change", { sender: this, callBack: triggerChange });

				let options = this.getOptions();
				if (options.checkboxes === false || options.checkboxes == null)
					this._selectedItem = this.getAllItems(true).filter(k => k.value == values[0])[0];
			}
		}

		setItems(items: any[], checkAll = false, ignoreExpandOption = false)
		{
			if (items == null) items = [];
			this.clear();
			items = items.filter(k => k != null);

			//#region Expand
			if (!ignoreExpandOption)
			{
				let options = (this.options as KendoWidgets.DropDownTreeOptions);
				switch (options.expand)
				{
					case TreeExpandEnum.All: this.expandAllInternal(items); break;
					case TreeExpandEnum.OnlyFirstLevel:
						{
							for (let item of items)
								item.expanded = true;
						}
						break;
				}
			}
			//#endregion

			this.dataSource.data(items);
			if (this.getAllItems().length <= 10)
			{
				this.popup.element.find(".k-list-filter").hide();

				if (items.length < 5)
					this.popup.element.find(".k-check-all").hide();
			}
			else if (items.length > 1)
			{
				if ((this.options as KendoWidgets.DropDownTreeOptions).showFilter) this.popup.element.find(".k-list-filter").show();
				if ((this.options as KendoWidgets.DropDownTreeOptions).checkAll) this.popup.element.find(".k-check-all").show();
			}

			let onlyToCheckItems = items.filter(k => k.checked);
			if (onlyToCheckItems.length > 0)
			{
				let allItems = this.getAllItems();
				let selectedItems = allItems.filter(k => k.checked);
				if (selectedItems.length == allItems.length)
					this.popup.element.find(".k-check-all").find("input").click();
				else
					this.setValues(onlyToCheckItems, false);

				this.writeTextByValues();
			}

			if (checkAll)
				this.checkAllNodes(false);
		}

		writeTextByValues()
		{
			let allItems = this.getAllItems();
			let selectedItems = allItems.filter(k => k.checked);

			//#region Input text
			let options = this.getOptions();
			let inputButton = this.element.parent().find(".k-button");
			if (inputButton.length == 0)
			{
				let addInputButton = true;
				if (options!.checkboxes != false && this.getCheckedItems().length == 0)
					addInputButton = false;

				if (addInputButton)
				{
					inputButton = $("<li class='k-button' unselectable='on' role='option'></li>");
					this.element.parent().find("ul[role='listbox']").append(inputButton);
				}
			}
			else if (inputButton.length > 1)
				$(inputButton[1]).remove();

			inputButton.html(selectedItems.map(k => k.text).toCommaSeparatedList());
			let textWidth = this.textWidth(inputButton);
			if (textWidth >= (inputButton.width() - 20))
				inputButton.html(selectedItems.length + " elementi");

			if (allItems.length == selectedItems.length)
				inputButton.html(options!.allSelectedMessage!);
				//#endregion
		}

		checkAllNodes(triggerChange = true)
		{
			this.setValues(this.getAllItems(false), triggerChange);
		}

		getSelectedItem()
		{
			return this._selectedItem;
		}

		getCheckedItems(onlyLeaf: boolean = true)
		{
			return this.getDataSourceItems(this.dataSource.data() as any, onlyLeaf, true);
		}

		getCheckedText(onlyLeaf: boolean = true)
		{
			return this.getCheckedItems(onlyLeaf).map(k => k.text);
		}

		getCheckedValues(onlyLeaf: boolean = true)
		{
			return this.getCheckedItems(onlyLeaf).map(k => k.value);
		}

		getAllItems(onlyLeaf: boolean = true)
		{
			return this.getDataSourceItems(this.dataSource.data() as any, onlyLeaf);
		}

		getDataItemByUid(uid: string)
		{
			return this.getAllItems().filter(k => k.uid == uid)[0];
		}

		private getDataSourceItems(dataElements: any[], onlyLeaf: boolean, onlyChecked: boolean = false): any[]
		{
			let items: any[] = [];
			for (let dataElement of dataElements)
			{
				if ((onlyLeaf && !dataElement.hasChildren) || !onlyLeaf)
				{
					if (onlyChecked && dataElement.checked)
						items.push(dataElement);
					else if (!onlyChecked)
						items.push(dataElement);
				}

				if (dataElement.hasChildren)
				{
					let tempItems = this.getDataSourceItems(dataElement.items, onlyLeaf, onlyChecked);
					for (let tempItem of tempItems)
						items.push(tempItem);
				}
			}

			return items;
		}

		private getAllLiItems(liItems?: HTMLElement[], onlyLeaf?: boolean): HTMLLIElement[]
		{
			if (liItems == null) liItems = Array.from(this.treeview.element.children().children());
			if (onlyLeaf == null) onlyLeaf = true;

			let liItemsResult: HTMLLIElement[] = [];
			for (let liItem of liItems)
			{
				let hasChildren = $(liItem).children("ul").length > 0;
				if ((onlyLeaf && !hasChildren) || !onlyLeaf)
					liItemsResult.push(liItem as HTMLLIElement);

				if (hasChildren)
				{
					if (!(this.options as DropDownTreeOptions).parentCheckbox)
						$(liItem).children(".k-top").children(".k-checkbox-wrapper").remove();

					let tempLiItems = this.getAllLiItems(Array.from($(liItem).children("ul").children("li")), onlyLeaf);
					liItemsResult.pushRange(tempLiItems);
				}
			}

			return liItemsResult;
		}

		//#region Expand/Collapse
		private expandAllInternal(dataElements: any[])
		{
			for (let dataElement of dataElements)
			{
				if (dataElement.items != null && dataElement.items.length > 0)
				{
					dataElement.expanded = true;
					this.expandAllInternal(dataElement.items);
				}
			}
		}

		private collapseAllInternal(dataElements: any[])
		{
			for (let dataElement of dataElements)
			{
				if (dataElement.items != null && dataElement.items.length > 0)
				{
					dataElement.expanded = false;
					this.collapseAllInternal(dataElement.items);
				}
			}
		}

		expandAll()
		{
			let items = this.getAllItems(false);
			this.expandAllInternal(items);
			this.setItems(items, false, true);
		}

		collapseAll()
		{
			let items = this.getAllItems(false);
			this.collapseAllInternal(items);
			this.setItems(items, false, true);
		}

		expandOnlyFirstLevel()
		{
			let items = this.getAllItems(false);
			for (let item of items)
				item.expanded = true;

			this.setItems(items, false, true);
		}
		//#endregion

		text(): string
		{
			if ((this.options as KendoWidgets.DropDownTreeOptions).checkboxes)
			{
				let selectedItem = this.getSelectedItem();
				if (selectedItem != null)
					return selectedItem.text;
				else
					return "";
			}
			else
			{
				return this.element.parent().find(".k-input").html()
			}
		}

		clear(checkFirstLeaf = false)
		{
			this._isClearing = true;
			if (!checkFirstLeaf)
				this.value([]);
			else
				this.setValues([this.getAllItems(true)[0].value], false);
			window.setTimeout(() => this._isClearing = false, 500);

			let options = this.getOptions();
			if (options.checkboxes === true)
			{
				let checkBoxAll = (this.popup.element.find(".k-check-all").children("input")[0] as HTMLInputElement);
				if (checkBoxAll != null)
					checkBoxAll.indeterminate = false;

				this.popup.element.find("li.k-item .k-checkbox").each(function (index, element)
				{
					let checkbox = (element as HTMLInputElement);
					if (checkbox != null)
						checkbox.checked = false;
				});
			}
		}

		clearItems()
		{
			this.dataSource.data([]);
		}

		isEmpty()
		{
			return (this.getCheckedItems().length == 0);
		}

		width(width?: string | number)
		{
			if (width != null)
				this.element.parent().width(width);

			return this.element.parent().width();
		}

		//#region Append
		appendTo(element: string | HTMLElement | JQuery)
		{
			this.element.parent().appendTo(element);
		}

		prependTo(element: string | HTMLElement | JQuery)
		{
			this.element.parent().prependTo(element);
		}
		//#endregion

		//#region Visible
		visible(visibleStatus?: boolean)
		{
			if (visibleStatus != null)
			{
				if (visibleStatus)
					this.element.parent().show();
				else
					this.element.parent().hide();
			}

			return this.element.parent().is(":visible");
		}

		show()
		{
			this.visible(true);
		}

		hide()
		{
			this.visible(false);
		}
		//#endregion

		private textWidth(object: HTMLElement | JQuery)
		{
			// Wrap text into span
			let originalHtmlText = $(object).html();
			let htmlCalculated = "<span style='display: inline-block; overflow-y: scroll; white-space: nowrap;'>" + originalHtmlText + "</span>";
			$(object).html(htmlCalculated);

			// Calculate width
			let width = $(object).find("span:first").width();

			// Restore original
			$(object).html(originalHtmlText);

			// Return width
			return width;
		}
	}

	DropDownTree.fn = DropDownTree.prototype;
	DropDownTree.fn.options = $.extend(true, {}, kendo.ui.DropDownTree.fn.options);
	DropDownTree.fn.options.name = "DropDownTree";
	kendo.ui.plugin(DropDownTree);

	export enum TreeExpandEnum
	{
		None,
		All,
		OnlyFirstLevel
	}
}

interface JQuery
{
	kendoDropDownTree(options?: KendoWidgets.DropDownTreeOptions): JQuery;
}